import { CountriesWithISOCodes } from '@/utils/intl';

export type CountryOption = {
    label: string;
    value: string;
};

// CountriesWithISOCodes pins US/GB/CA to the top for convenience but also lists them again
// in their normal alphabetical position, so dedupe by code to avoid duplicate options.
const seenCountryCodes = new Set<string>();
export const countryOptions: CountryOption[] = CountriesWithISOCodes.reduce<CountryOption[]>((options, country) => {
    if (seenCountryCodes.has(country.code)) {
        return options;
    }
    seenCountryCodes.add(country.code);
    options.push({ label: country.name, value: country.code });
    return options;
}, []);

export const findCountryByCode = (countryCode: string): CountryOption | undefined =>
    countryOptions.find((country) => country.value === countryCode);

export const findCountryByName = (countryName: string): CountryOption | undefined =>
    countryOptions.find((country) => country.label === countryName);
